export type FixMe = any;

export const replaceWildcards = (wildcardString: FixMe, wildcards: FixMe) => {
	let returnValue = wildcardString;
	wildcards.forEach((wildcard: FixMe) => {
		returnValue = returnValue.replace(wildcard.replaceKey, wildcard.replaceValue);
	});
	return returnValue;
};
